/**
 * Кастомный календарь для inputов
 *
 * @param {jQuery} $input jQuery-объект поля, в которое будет вставлена дата
 * @param {Date} minDate минимальная дата
 * @param {Date} maxDate максимальная дата
 */
$.fn.inputCalendar = function ($input, minDate, maxDate) {
    if (typeof $.fn.datepicker === 'undefined') {
        console.error('customCalendar: datepicker is not defined!');
        return;
    }

    let $self = $(this);

    /**
     * Добавляем выбор месяца/года
     */
    const initMonthSelect = function () {
        let $filterMonth = $('<select>', {
            class: 'js-select2 calendar-filter-month',
            attr: {
                'data-select2-class': 'select2-filter-month'
            },
            append: function () {
                let monthArray = [
                    'Январь',
                    'Февраль',
                    'Март',
                    'Апрель',
                    'Май',
                    'Июнь',
                    'Июль',
                    'Август',
                    'Сентябрь',
                    'Октябрь',
                    'Ноябрь',
                    'Декабрь'
                ];

                return monthArray.map(function (el, index) {
                    return $('<option>', {
                        value: index,
                        text: el,
                        selected: index === minDate.getMonth()
                    });
                });
            }
        });

        let $filterYear = $('<select>', {
            class: 'js-select2 calendar-filter-year',
            attr: {
                'data-select2-class': 'select2-filter-year'
            },
            append: function () {
                let minYear = minDate.getFullYear();
                let maxYear = maxDate.getFullYear();
                let optionsArray = [];

                for (let i = minYear; i <= maxYear; i++) {
                    optionsArray.push($('<option>', {
                        value: i,
                        text: i,
                        selected: i === minDate.getFullYear()
                    }));
                }

                return optionsArray;
            }
        });

        let $closeBtn = $('<button>', {
            class: 'js-hide-calendar calendar-close-btn',
            type: 'button'
        });

        $self.prepend($('<div>', {
            class: 'calendar-filter js-calendar-filter',
            append: [
                $filterMonth,
                $filterYear,
                $closeBtn
            ]
        }));

        // Инициализация select2 для полей выбора года/месяца
        $('.js-calendar-filter .js-select2').each(function () {
            let $select = $(this);

            $select.select2({
                width: 'style',
                dropdownParent: $select.parent(),
                containerCssClass: $select.data('select2-class')
            });

            $select.on('change', function () {
                let datepicker = $self.data('datepicker');
                let selectedYear = parseInt($('.js-select2.calendar-filter-year').val());
                let selectedMonth = (parseInt($('.js-select2.calendar-filter-month').val()) + 1).toString().padStart(2, '0');

                if (typeof datepicker !== 'undefined') {
                    datepicker.date = new Date(`${selectedYear}-${selectedMonth}-01`);
                }
            });

            // Если подключен PerfectScrollbar - подключаем кастомный скролл в выпадающих списках
            if (typeof PerfectScrollbar === 'undefined') {
                return;
            }

            $select.on('select2:open', function () {
                $('.select2-results__options').each(function (index, el) {
                    if (typeof $(el).data('ps') === 'undefined') {
                        $(el).data('ps', new PerfectScrollbar(el, {
                            suppressScrollX: true
                        }));
                    }

                    setTimeout(function () {
                        $(el).data('ps').update();
                    }, 100);
                });
            });
        });

        // Страница не должна скроллиться, пока скроллится список опций
        $(document).on('wheel', '.select2-results__options', function (e) {
            e.preventDefault();
        });
    };

    /**
     * Инициализация
     */
    const init = function () {
        if (typeof $.fn.select2 !== 'undefined') {
            initMonthSelect();
        }

        // Инициализация датапикера
        $self.datepicker({
            inline: true,
            minDate: minDate,
            maxDate: maxDate, // нельзя читать из будущего - у одних ребят была куча проблем из-за этого в 1985 году
            startDate: minDate,
            toggleSelected: false,
            selectOtherMonths: false,
            onRenderCell: function (date, cellType) {
                // форматирование ячеек календаря
                let datesArray = $self.data('dates');
                let dateDayString = date.getDate().toString().padStart(2, '0');
                let dateMonthString = (date.getMonth() + 1).toString().padStart(2, '0');
                let dateText = `${date.getFullYear()}-${dateMonthString}-${dateDayString}`;

                if (typeof datesArray !== 'undefined' && cellType === 'day') {
                    if (datesArray.indexOf(dateText) !== -1) {
                        return {
                            classes: '-has-event-'
                        };
                    } else {
                        return {
                            disabled: true
                        };
                    }
                }
            },
            onSelect: function (formattedDate, date) {
                $input.val(formattedDate).trigger('change');
            }
        });
    };

    init();
};
